// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 230) return "static/chunks/230-a374c07460943fc1.js";
	if (chunkId === 547) return "static/chunks/547-8c4a6db44c64289b.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 806 ? "4163ae0c" : chunkId) + "." + {"1":"33e670cb937bfd93","98":"b459b14224445ebb","270":"5c4342bb214c0718","496":"c4bad96338920f2d","686":"77dfb9bb649a43d0","806":"611492ddd6e516ab"}[chunkId] + ".js";
};